module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_main_emerald_beach-af46d9a7552d89c544aa36b908d5ce67.jpg";